/*
 * cluutch-atc-price.js
 * CRO wave 2 (PDP-M) — tient à jour le prix repris dans le bouton d'ajout au panier.
 *
 * Sur téléphone, le bouton porte le prix à côté de son libellé : c'est le dernier
 * élément lu avant le geste d'achat, et il évite de remonter chercher le prix sous
 * le titre. Le montant initial est rendu côté serveur (aucun décalage au chargement) ;
 * ce script ne fait que le suivre quand la variante change.
 *
 * Choix structurants :
 * - le prix est un FRÈRE du libellé, jamais dedans : product.js réécrit
 *   `.single-add-to-cart-button--text` en textContent à chaque changement de variante
 *   et à l'indisponibilité, tout HTML placé dedans serait effacé ;
 * - mise à jour SCOPÉE par detail.sectionId : le même snippet d'achat est aussi rendu
 *   par le quick-view et par la section « produit en vedette ». Sans ce filtre, changer
 *   de teinte dans le quick-view réécrirait le prix du bouton de la fiche en dessous ;
 * - garde sur detail.variant : custom.js re-diffuse le même événement SANS detail ;
 * - formatage par formatMoney() avec le format du thème (shop.money_format), donc un
 *   rendu strictement identique au filtre `money` du serveur ;
 * - variante indisponible : on masque le prix et on laisse « Épuisé » seul.
 * Style dans cluutch-pdp.css. Auteur : Cluutch / Studio Hogo.
 */
(function () {
	if (window.cluutchAtcPriceReady) return;
	window.cluutchAtcPriceReady = true;

	function majPrix(portee, variante) {
		// Fiche 2026 : le moteur d'achat écrit le total (rouge + articles cochés, ou le coffret)
		// en `data-cluutch-total` sur <product-form> ; le bouton dit ce total, pas le prix unitaire.
		var total = portee.dataset.cluutchTotal ? parseInt(portee.dataset.cluutchTotal, 10) : null;
		portee.querySelectorAll('[data-cluutch-atc-price]').forEach(function (el) {
			if (!variante || variante.available === false) {
				el.hidden = true;
				return;
			}
			if (typeof formatMoney === 'function' && typeof variante.price === 'number') {
				var format =
					(window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) ||
					'{{amount}}';
				el.innerHTML = formatMoney(total !== null && !isNaN(total) ? total : variante.price, format);
			}
			el.hidden = false;
		});
	}

	// Le même total, au changement d'état du moteur (case cochée) : la variante n'a pas changé,
	// un prix masqué (variante épuisée) le reste.
	document.addEventListener('cluutch:pdp-total', function (e) {
		if (!e.detail || !e.detail.sectionId || typeof formatMoney !== 'function') return;
		var portee = document.querySelector('product-form[data-section="' + e.detail.sectionId + '"]');
		if (!portee) return;
		var format = (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) || '{{amount}}';
		portee.querySelectorAll('[data-cluutch-atc-price]').forEach(function (el) {
			if (!el.hidden) el.innerHTML = formatMoney(e.detail.total, format);
		});
	});

	document.addEventListener('product:variant-change', function (e) {
		// custom.js re-diffuse cet événement sans detail : on l'ignore.
		if (!e.detail || !e.detail.variant) return;

		// Une seule zone d'achat concernée : celle de la section qui a émis.
		var portee = e.detail.sectionId
			? document.querySelector('product-form[data-section="' + e.detail.sectionId + '"]')
			: null;
		if (!portee) return;

		majPrix(portee, e.detail.variant);
	});
})();
